// lib/texting.ts · v12.10.27 (#2150 senderName on the status) · 2026-10-31
// texting.ts · v12.10.26 (#T154 Text messaging - the outgoing wording rule (mirror of TextingRules.ApplyOutgoingWording) + the texting status Messages reads) · 2026-10-30 · VoiceSpectrum AI
import { useQuery } from '@tanstack/react-query';
import api from './api';

export const PHONE_TOKEN = '{organization.phone}';
export const TEXT_LANGS: { code: string; label: string }[] = [
  { code: 'en', label: 'English' }, { code: 'es', label: 'Spanish' }, { code: 'zh', label: 'Chinese' },
];

// v12.10.26 (#T154 Q3 TC9): the closing sentence of our texts follows Text replies - read-only, never typed by the practice.
export function closingLine(lang: string, repliesOn: boolean): string {
  if (lang === 'es') return repliesOn ? 'Responda o llámenos al {organization.phone} si necesita cambiarla.' : 'Llámenos al {organization.phone} si necesita cambiarla.';
  if (lang === 'zh') return repliesOn ? '如需更改，请回复或致电 {organization.phone}。' : '如需更改，请致电 {organization.phone}。';
  return repliesOn ? 'Reply or call us at {organization.phone} if you need to change it.' : 'Call us at {organization.phone} if you need to change it.';
}

// v12.10.26 (#T154): {organization.phone} -> the office number; with none on file the " at {organization.phone}" part is dropped.
export function renderPhone(text: string, officePhone?: string | null): string {
  if (officePhone && officePhone.trim()) return text.split(PHONE_TOKEN).join(officePhone.trim());
  return text.replace(/\s*(?:at|al|：|:)\s*\{organization\.phone\}/gi, '').split(PHONE_TOKEN).join('');
}

const EN_CLOSE = /(?:Reply or call us|Call us)(?: at [^ ]+(?: [^ ]+)?)? if you need to change it\.?/i;
const ES_CLOSE = /(?:Responda o llámenos|Llámenos)(?: al [^ ]+(?: [^ ]+)?)? si necesita cambiarla\.?/i;

// v12.10.26 (#T154 Q3, #1879): rewrite the "change it" sentence of a template so it follows Text replies and points to the main office line.
export function applyOutgoingWording(body: string, repliesOn: boolean, officePhone?: string | null): string {
  return body
    .replace(EN_CLOSE, () => renderPhone(closingLine('en', repliesOn), officePhone))
    .replace(ES_CLOSE, () => renderPhone(closingLine('es', repliesOn), officePhone));
}

export interface TextingStatus { repliesOn: boolean; workflowOn: boolean; officePhone?: string | null; textCount?: number | null; senderName?: string | null }   // v12.10.27 (#2150): senderName

// v12.10.26 (#T154 Q9 TC8): Text replies / the workflow / the office number / the Text Messages count - for Messages.
export function useTextingStatus() {
  return useQuery<TextingStatus>({
    queryKey: ['t2-texting-status'],
    queryFn: () => api.get<TextingStatus>('/t2/texting/status'),
    staleTime: 60_000,
    retry: false,
  });
}
